import { Component, OnInit,ViewChild } from '@angular/core';
import { SupplierService } from 'app/shared/services/supplier.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'app-view-supplier',
  templateUrl: './view-supplier.component.html',
  styleUrls: ['./view-supplier.component.css']
})
export class ViewSupplierComponent implements OnInit {

  displayedColumns: string[] = ['SupId', 'SupName', 'Phone', 'Email','Status','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  dataList:any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
                private supplierService : SupplierService, 
                private dialogService : DialogService,
                private router : Router, 
                private route : ActivatedRoute,
                private themeService: NbThemeService,
                private toastr: ToastrService,
                private authService: AuthService,
              ) { }

  ngOnInit() {

    this.getAllSuppliers();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='SM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }
  

  getAllSuppliers(){
    this.supplierService.getAll()
     .subscribe(
        (data) => {
                  this.dataList = data;
                  this.dataSource = new  MatTableDataSource (this.dataList);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                   
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }
   
    newButtonClick(){
    this.supplierService.dataRow = null;
    this.router.navigate(['../supplier'],{relativeTo : this.route});

   
    }

    getRowData(row){   
      this.supplierService.dataRow = row;  
      this.router.navigate(['../supplier'],{relativeTo : this.route});
     
   }


     deleteButtonClick(supId: string){

       this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.supplierService.deleteSupplier(supId)
        .subscribe(
          (res) => {
                      this.toastr.success('Record deleted successfully','Success');
                      this.getAllSuppliers();
                          
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
   }

   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }


}
